export var keyDownHandler = function keyDownHandler(itemRefs, index) {
  return function (event) {
    var key = event.key;

    if (key === ' ' || key === 'Enter') {
      var item = itemRefs[0].current;
      item && item.click();
    } else if (key === 'ArrowDown' || key === 'Down' || key === 'ArrowRight' || key === 'Right') {
      var nextIndex = index < itemRefs.length - 1 ? index + 1 : 0;
      var nextItem = itemRefs[nextIndex].current;
      nextItem && nextItem.focus();
      nextItem && nextItem.click();
    } else if (key === 'ArrowUp' || key === 'Up' || key === 'ArrowLeft' || key === 'Left') {
      var prevIndex = index > 0 ? index - 1 : itemRefs.length - 1;
      var prevItem = itemRefs[prevIndex].current;
      prevItem && prevItem.focus();
      prevItem && prevItem.click();
    }
  };
};